import { gql } from '@apollo/client'

export const GET_FABRIC_PALETTES = gql`
  query GET_FABRIC_PALETTES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [FabricPaletteOrderByWithRelationInput!]
  ) {
    findManyFabricPaletteCount(
      where: { OR: [{ name: { mode: insensitive, contains: $searchTerm } }, { code: { mode: insensitive, contains: $searchTerm } }] }
    )
    findManyFabricPalette(
      orderBy: $orderBy
      where: { OR: [{ name: { mode: insensitive, contains: $searchTerm } }, { code: { mode: insensitive, contains: $searchTerm } }] }
      take: $take
      skip: $skip
    ) {
      id
      name
      code
      createdAt

      _count {
        fabric_groups
      }
    }
  }
`

export const DELETE_MANY_FABRIC_PALETTES = gql`
  mutation DELETE_MANY_FABRIC_PALETTES($ids: [Int!]!) {
    deleteManyFabricPalette(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const CREATE_FABRIC_PALETTE = gql`
  mutation CREATE_FABRIC_PALETTE(
    $name: String!
    $code: String
    $fabric_groups_with_names: [FabricGroupWithNameInput!]
  ) {
    createFabricPalette(
      name: $name
      code: $code
      fabric_groups_with_names: $fabric_groups_with_names
    ) {
      id
      name
      code
    }
  }
`

// Light list for the "add fabric group" picker (no fabrics).
export const SEARCH_FABRIC_GROUPS_FOR_PALETTE = gql`
  query SEARCH_FABRIC_GROUPS_FOR_PALETTE($searchTerm: String, $take: Int) {
    findManyFabricGroup(
      take: $take
      orderBy: [{ code: { sort: asc } }]
      where: {
        OR: [
          { code: { mode: insensitive, contains: $searchTerm } }
          {
            fabric_group_profiles: {
              some: { name: { mode: insensitive, contains: $searchTerm } }
            }
          }
        ]
      }
    ) {
      id
      code
      fabric_group_profiles {
        name
        language
      }
    }
  }
`

// Same shape as GET_FABRIC_PALETTE's fabric_group, fetched when a group is added.
export const GET_FABRIC_GROUP_FOR_PALETTE = gql`
  query GET_FABRIC_GROUP_FOR_PALETTE($id: Int!) {
    findUniqueFabricGroup(where: { id: $id }) {
      id
      code
      manufacturer {
        id
      }
      fabric_price_category {
        id
        group_number
      }
      fabric_group_profiles {
        name
        language
      }
      fabrics {
        id
        code
        color_name
        order
        image {
          src
          src_thumbnail
        }
      }
    }
  }
`

export const UPDATE_FABRIC_PALETTE = gql`
  mutation UPDATE_FABRIC_PALETTE(
    $where: FabricPaletteWhereUniqueInput!
    $name: String!
    $code: String
    $fabric_groups_with_names: [FabricGroupWithNameInput!]
  ) {
    updateFabricPalette(
      where: $where
      name: $name
      code: $code
      fabric_groups_with_names: $fabric_groups_with_names
    ) {
      id
      createdAt
      name
      code
    }
  }
`

export const GET_FABRIC_PALETTE = gql`
  query GET_FABRIC_PALETTE($id: Int!) {
    findUniqueFabricPalette(where: { id: $id }) {
      id
      name
      code
      updatedAt
      fabric_groups {
        id
        name
        color_codes
        color_overrides
        fabric_group {
          id
          code
          manufacturer {
            id
          }
          fabric_price_category {
            id
            group_number
          }
          fabric_group_profiles {
            name
            language
          }
          fabrics {
            id
            code
            color_name
            order
            image {
              src
              src_thumbnail
            }
          }
        }
      }
    }
  }
`

// Price categories of one manufacturer (options for the colour category override).
export const GET_FABRIC_PRICE_CATEGORIES_FOR_PALETTE = gql`
  query GET_FABRIC_PRICE_CATEGORIES_FOR_PALETTE($manufacturerId: Int!) {
    findManyFabricPriceCategory(
      where: { manufacturerId: { equals: $manufacturerId } }
      orderBy: [{ group_number: asc }]
    ) {
      id
      group_number
    }
  }
`
